import apiService, { ApiService } from './ApiService';
import { apis } from '../utility/constants';
import { List, ListParams } from '../types/main';
import { Customer, ItemId } from '../types/items';
import { transformList } from './transformer';

class CustomerService {
  private route = apis.customer;

  constructor(private api: ApiService) {}

  list = (params: ListParams) => this.api
    .get<List<Customer>>(this.route.list, params)
    .then(transformList);

  get = (id: ItemId) => this.api.get<Customer>(`${this.route.list}/${id}`);

  template = () => this.api.get<Customer>(`${this.route.list}/new`);

  create = ({
    id,
    ref,
    permissions,
    ...customer
  }: Customer) => this.api.post<Customer>(this.route.list, customer);

  save = (id: ItemId, payload: Customer) => this.api.put<Customer>(`${this.route.list}/${id}`, payload);

  delete = (id: ItemId) => this.api.delete(`${this.route.list}/${id}`);

}

export default new CustomerService(apiService);
